import { Expose } from 'class-transformer';

export class AppointmentCancelTypeDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;
}
